// Modal_style.js
import { zoom } from '../zoomUtils.js';
import { getColor } from '../StyleBase_style.js';

export const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: zoom('20px')
  },

  overlayMobile: {
    padding: zoom('10px')
  },

  content: {
    background: getColor('primaryDark'),
    borderRadius: zoom('16px'),
    boxShadow: `
      0 0 ${zoom('60px')} rgba(108, 163, 208, 0.4),
      0 ${zoom('20px')} ${zoom('40px')} rgba(0, 0, 0, 0.3)
    `,
    backdropFilter: `blur(${zoom('20px')})`,
    WebkitBackdropFilter: `blur(${zoom('20px')})`,
    border: `${zoom('2px')} solid rgba(64, 230, 202, 0.3)`,
    width: '100%',
    maxWidth: zoom('600px'),
    maxHeight: '80vh',
    position: 'relative',
    zIndex: 2001
  },

  contentMobile: {
    maxHeight: '90vh',
    borderRadius: zoom('12px')
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${zoom('20px')} ${zoom('24px')} 0`,
    borderBottom: `${zoom('1px')} solid rgba(64, 230, 202, 0.2)`,
    marginBottom: zoom('20px')
  },

  headerMobile: {
    padding: `${zoom('16px')} ${zoom('20px')} 0`
  },

  title: {
    color: getColor('secondary'),
    fontSize: zoom('24px'),
    margin: 0,
    textShadow: `0 0 ${zoom('10px')} rgba(173, 218, 239, 0.3)`
  },

  titleMobile: {
    fontSize: zoom('20px')
  },

  closeButton: {
    background: 'none',
    border: 'none',
    color: getColor('secondary'),
    fontSize: zoom('28px'),
    cursor: 'pointer',
    padding: 0,
    width: zoom('32px'),
    height: zoom('32px'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'all 0.2s ease'
  },

  closeButtonHover: {
    background: 'rgba(64, 230, 202, 0.1)',
    color: getColor('primaryAccent'),
    transform: 'scale(1.1)'
  },

  body: {
    padding: `0 ${zoom('24px')} ${zoom('24px')}`,
    color: getColor('secondary'),
    lineHeight: 1.6,
    overflowY: 'auto',
    maxHeight: 'calc(80vh - 120px)'
  },

  bodyMobile: {
    padding: `0 ${zoom('20px')} ${zoom('20px')}`,
    maxHeight: 'calc(90vh - 100px)'
  },

  bodyH3: {
    color: '#ADDAEF',
    textShadow: `0 0 ${zoom('10px')} rgba(173, 218, 239, 0.3)`,
    margin: `${zoom('20px')} 0 ${zoom('8px')} 0`,
    fontSize: zoom('18px')
  },

  // Animation styles
  overlayEntering: {
    animation: 'modalFadeIn 0.3s ease-out'
  },

  overlayExiting: {
    animation: 'modalFadeOut 0.15s ease-out forwards'
  },

  contentEntering: {
    animation: 'modalSlideIn 0.3s ease-out'
  },

  contentExiting: {
    animation: 'modalSlideOut 0.15s ease-out forwards'
  }
};

export const getModalStyles = () => {
  const isMobile = window.innerWidth <= 767;
  
  return {
    overlay: {
      ...modalStyles.overlay,
      ...(isMobile ? modalStyles.overlayMobile : {})
    },
    content: {
      ...modalStyles.content,
      ...(isMobile ? modalStyles.contentMobile : {})
    },
    header: {
      ...modalStyles.header,
      ...(isMobile ? modalStyles.headerMobile : {})
    },
    title: {
      ...modalStyles.title,
      ...(isMobile ? modalStyles.titleMobile : {})
    },
    closeButton: modalStyles.closeButton,
    body: {
      ...modalStyles.body,
      ...(isMobile ? modalStyles.bodyMobile : {})
    },
    bodyH3: modalStyles.bodyH3
  };
};

// Function to inject keyframe animations
export const injectModalAnimations = () => {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes modalFadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    @keyframes modalFadeOut {
      from { opacity: 1; }
      to { opacity: 0; }
    }
    
    @keyframes modalSlideIn {
      from {
        opacity: 0;
        transform: scale(0.9) translateY(-20px);
      }
      to {
        opacity: 1;
        transform: scale(1) translateY(0);
      }
    }
    
    @keyframes modalSlideOut {
      from {
        opacity: 1;
        transform: scale(1) translateY(0);
      }
      to {
        opacity: 0;
        transform: scale(0.9) translateY(-20px);
      }
    }
  `;
  document.head.appendChild(style);
};